  import './sidebar.css';
  import React, { useEffect, useState } from "react";
  import SideNav, { NavItem, NavIcon, NavText } from "@trendmicro/react-sidenav";
  import { Icon,Button } from 'react-materialize';
  import ModalPedido from '../modals/modalPedidos';
  import ModalExistences from '../modals/modalExistences';
  import ModalNewCustomer from '../modals/modalNewCustomer';
  import ModalInvoices from '../modals/modalInvoices';
  import ModalOC from '../modals/modalOC';
  import ModalWarehouse from '../modals/modalWarehouse';
  import ModalCambioPrecios from '../modals/modalCambioPrecios';
  import ModalRemision from '../modals/modalRemision';
  import ModalCancel from '../modal-cancel-report/modalCancel';
  import ModalReporte from '../modal-reporte/modal-reporte.view';
  import ModalProducts from '../modal-products/modal-products.view';
  import ModalReporte2 from '../modal-reporte2/modal-reporte.view';
  import ModalFaq from '../modals/modalFaq';
  import ModalCheckin from '../modals/modalCheckin';
  import ModalCheckinRep from '../modals/modalCheckinRep';
  import ModalIndicators from '../modals/modalIndicadores';
  import ModalRemoteOrders from '../modals/ModalRemoteOrders';
  import ModalForaneos from '../modals/ModalForaneos';
import ModalForaneosRep from '../modals/ModalForaneosRep';
import ModalInventoryLookup from "../modals/ModalInventoryLookup";
import ModalWarehouseAgents from "../modals/ModalWarehouseAgents";
import ably from "../../../ablyClient"; 


  function SideBarView(props) {

    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const [solicitudesPendientes, setSolicitudesPendientes] = useState(0);
 
    const [solicitudes, setSolicitudes] = useState([]);
    const userLogin = (user?.user || user?.username || user?.usr || user?.name || '')
      .toString()
      .trim()
      .toLowerCase();
    
 const warehouseManagerScope =
    userLogin === 'jdomingu'
      ? { login: 'jdomingu', site: '3000', siteLabel: '3000 (MTY)' }
      : userLogin === 'omartine'
        ? { login: 'omartine', site: '3100', siteLabel: '3100 (CDMX)' }
        : null;

  const isWarehouseManager = !!warehouseManagerScope;
  const forcedWarehouseSite = warehouseManagerScope?.site || null;

  const reporte = user.reporte_ventas;
  const canCancel = user.orderCanc || !user.departmentId;


    const cargarPendientes = async () => {
      try {
        const res = await fetch("/api/cart-price-request/pending");
        const data = await res.json();

        setSolicitudes(data.solicitudes);
        setSolicitudesPendientes(data.total);

      } catch (err) {
        console.error(err);
      }
    };



    useEffect(() => {

      if (!["002", "001"].includes(user?.departmentId)) {
        return;
      }

      cargarPendientes();

      const channel = ably.channels.get("price-requests");

      channel.subscribe("new-request", () => {
        cargarPendientes();
      });

      return () => {
        channel.unsubscribe();
      };

    }, [user.departmentId]);
      return (
          <div className="sidebar">
              <SideNav onToggle={props.onToggleDetail}>
                  <SideNav.Toggle />
                  <SideNav.Nav defaultSelected="home">
                      {canCancel === "1" && (
                          <NavItem title="Cancelar Pedidos Masivos">
                              <NavIcon onClick={props.modalCancelOpen}>
                                  <Icon large>auto_delete</Icon>
                              </NavIcon>
                          </NavItem>
                      )}
                      <NavItem title="Pedidos">
                          <NavIcon onClick={props.openModalPedidos}>
                              <Icon large>local_shipping</Icon>
                          </NavIcon>
                      </NavItem>

                      <NavItem title="Remisión">
                          <NavIcon onClick={props.openModalRemision}>
                              <Icon large>inventory_2</Icon>
                          </NavIcon>
                      </NavItem>

                      <NavItem title="Factura">
                          <NavIcon onClick={props.modalInvoicesOpen}>
                              <Icon large>folder</Icon>
                          </NavIcon>
                      </NavItem>

                      <NavItem title="Artículos">
                          <NavIcon onClick={props.openModalArticulos}>
                              <Icon large>local_offer</Icon>
                          </NavIcon>
                      </NavItem>

                      <NavItem title="Existencias">
                          <NavIcon onClick={props.openModalExistences}>
                              <Icon large>find_in_page</Icon>
                          </NavIcon>
                      </NavItem>

                      <NavItem title="Agregar Clientes">
                          <NavIcon onClick={props.modalNewCustomerOpen}>
                              <Icon large>person_add</Icon>
                          </NavIcon>
                      </NavItem>

                      <NavItem title="Crear OC">
                          <NavIcon onClick={props.modalOCOpen}>
                              <Icon large>assignment_returned</Icon>
                          </NavIcon>
                      </NavItem>

                      <NavItem title="Rack">
            <NavIcon>
              <Icon large>computer</Icon>
            </NavIcon>

            <NavItem>
              <NavText onClick={props.modalRackOpen}>Inventario (Conteo)</NavText>
            </NavItem>

            <NavItem>
              <NavText onClick={props.modalInventoryLookupOpen}>
                Buscar artículo (Conteo vs QAD)
              </NavText>
            </NavItem>
          </NavItem>                      
                      <NavItem title="Reportes">
  <NavIcon>
    <Icon large>assignment</Icon>
  </NavIcon>
  <NavItem>
    <NavText onClick={props.openModalReporte}>Reporte de pedidos</NavText>
  </NavItem>
  <NavItem>
    <NavText onClick={props.modalIndicatorsOpen}>Indicadores</NavText>
  </NavItem>
  <NavItem>
    <NavText onClick={props.modalCheckinRepOpen}>Reporte de Turnos</NavText>
  </NavItem>
  <NavItem>
    <NavText onClick={props.modalForaneosRepOpen}>Reporte Foráneos</NavText>
  </NavItem>
</NavItem>

 {isWarehouseManager && (
            <NavItem title={`Agentes Almacén (Admin)${warehouseManagerScope?.siteLabel ? ` - ${warehouseManagerScope.siteLabel}` : ''}`}>
              <NavIcon onClick={props.modalWarehouseAgentsOpen}>
                <Icon large>supervisor_account</Icon>
              </NavIcon>
            </NavItem>
          )}                      <NavItem title="Checkin">
                          <NavIcon onClick={props.modalCheckinOpen}>
                              <Icon large>tag</Icon>
                          </NavIcon>
                      </NavItem>
                      <NavItem title="Pedidos Remotos">
    <NavIcon onClick={props.modalRemoteOrdersOpen}>
      <Icon large>outbox</Icon> 
    </NavIcon>
  </NavItem>

  <NavItem title="Foráneos">
  <NavIcon
    onClick={() => {
      props.modalForaneosOpen();
    }}
  >
    <Icon large>forward_to_inbox</Icon>
  </NavIcon>

  </NavItem>
                      <NavItem title="Ayuda">
                          <NavIcon onClick={props.modalFaqOpen}>
                              <Icon large>help</Icon>
                          </NavIcon>
                      </NavItem>
                      
              {["002","001"].includes(user?.departmentId) && (
                <NavItem title="Notificaciones">
                  <NavIcon>
                    <div style={{ position: "relative" }}>
                      <Icon large>notifications</Icon>

                      {solicitudesPendientes > 0 && (
                        <span className="notification-badge">
                          {solicitudesPendientes}
                        </span>
                      )}
                    </div>
                  </NavIcon>

                  {solicitudes.length === 0 && (
                    <NavItem>
                      <NavText>Sin notificaciones</NavText>
                    </NavItem>
                  )}

                  {solicitudes.map((sol) => (
                    <NavItem key={sol.id}>
                      <NavText onClick={() => props.modalCambioPreciosOpen(sol)}>
                        {sol.client_id + '-' + sol.requested_name}
                      </NavText>
                    </NavItem>
                  ))}

                </NavItem>
              )}


                  </SideNav.Nav>
              </SideNav> 
                <ModalPedido
                  catalog={props.catalog}
                  modalPedidosIsOpen={props.modalPedidosIsOpen}
                  onClose={props.closeModalPedidos}
                  makeRemission={props.makeRemission}
                  turn={props.turn} 
                />
                <ModalRemision
                  catalog={props.catalog}
                  modalRemisionIsOpen={props.modalRemisionIsOpen}
                  getInventoryAndPrices={props.getInventoryAndPrices}
                  insertIntoLocalStorage={props.insertIntoLocalStorage}
                  onClose={props.closeModalRemision}
                />
                <ModalProducts
                  allProducts={props.allProducts}
                  catalog={props.catalog}
                  url={props.url}
                  urlPass={props.urlPass}
                  modalArticulosIsOpen={props.modalArticulosIsOpen}
                  onClose={props.closeModalArticulos}
                />
                <ModalReporte
                  modalReporteIsOpen={props.modalReporteIsOpen}
                  onClose={props.closeModalReporte}
                  catalog={props.catalog}
                />
                <ModalExistences
                  catalog={props.catalog}
                  isOpen={props.modalExistencesIsOpen}
                  onClose={props.closeModalExistences}
                />
                <ModalNewCustomer
                  catalog={props.catalog}
                  isOpen={props.modalNewCustomerIsOpen}
                  user={user}
                  onClose={props.modalNewCustomerClose}
                />
                <ModalInvoices
                  isOpen={props.modalInvoicesIsOpen}
                  onClose={props.modalInvoicesClose}
                />
                <ModalOC
                  catalog={props.catalog}
                  isOpen={props.modalOCIsOpen}
                  onClose={props.modalOCClose}
                />
                <ModalWarehouse
                  catalog={props.catalog}
                  isOpen={props.modalRackIsOpen}
                  onClose={props.modalRackClose}
                  isRack={true}
                />
<ModalCambioPrecios
  catalog={props.catalog}
  isOpen={props.modalCambioPreciosIsOpen}
  onClose={props.modalCambioPreciosClose}
  solicitud={props.solicitudSeleccionada}
  colocarPedido={props.colocarPedido}
/>


<ModalInventoryLookup
        isOpen={props.modalInventoryLookupIsOpen}
        onClose={props.modalInventoryLookupClose}
        catalog={props.catalog}
        user={user}
      />
                <ModalCancel
                  isOpen={props.modalCancelIsOpen}
                  onClose={props.modalCancelClose}
                  catalog={props.catalog}
                />
                <ModalCheckin
                  isOpen={props.modalCheckinIsOpen}
                  onClose={props.modalCheckinClose}
                  catalog={props.catalog}
                />
                <ModalIndicators
                isOpen={props.modalIndicatorsIsOpen}
                onClose={props.modalIndicatorsClose}
                  catalog={props.catalog}
                  />
                
                <ModalReporte2
                  modalReporte2IsOpen={props.modalReporte2IsOpen}
                  onClose={props.closeModalReporte2}
                  catalog={props.catalog}
                />
                <ModalFaq
                  isOpen={props.modalFaqIsOpen}
                  onClose={props.modalFaqClose}
                  url={props.url}
                  urlPass={props.urlOnlyPass}
                  urlfaq={props.urlfaq}               
                  urlfaq1={props.urlfaq1}
                />
{props.modalCheckinIsOpen && (
  <ModalCheckin
    onClose={props.modalCheckinClose}
    catalog={props.catalog}
  />
)}
              <ModalCheckinRep
                catalog={props.catalog}
                user={user}
                isOpen={props.modalCheckinRepIsOpen}
                onClose={props.modalCheckinRepClose}
              />
 


  {props.modalRemoteOrdersIsOpen && (
    <ModalRemoteOrders
  open={props.modalRemoteOrdersIsOpen}
  onClose={props.modalRemoteOrdersClose}
  user={props.user}
  catalog={props.catalog}

/>
  )}

  {props.modalForaneosIsOpen && (
    <ModalForaneos
      open={props.modalForaneosIsOpen}
      onClose={props.modalForaneosClose}
      user={user}
      Button={Button}
      catalog={props.catalog}

    />
  )}
{props.modalForaneosRepIsOpen && (
  <ModalForaneosRep
    isOpen={props.modalForaneosRepIsOpen}
    onClose={props.closeModalForaneosRep}   
     user={props.user}
    catalog={props.catalog}
  />
)}

    {props.modalWarehouseAgentsIsOpen && (
        <ModalWarehouseAgents
          isOpen={props.modalWarehouseAgentsIsOpen}
          onClose={props.modalWarehouseAgentsClose}
          forcedSite={forcedWarehouseSite}
          warehouseManagerScope={warehouseManagerScope}
        />
      )}
    </div>
  );
}

  export { SideBarView as default };
